import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../hooks/authSlice';
import summaryReducer from '../hooks/summarySlice';
import toastReducer from '../hooks/toastSlice';
// import userReducer from '../hooks/userSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    summary: summaryReducer,
    toast: toastReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore Firebase user object in actions
        ignoredActions: [
          'auth/observeAuthState/fulfilled',
          'auth/signInWithGoogle/fulfilled',
          'auth/handleRedirectResult/fulfilled',
        ],
        // Ignore Firebase user object in state
        ignoredPaths: ['auth.user'],
      },
    }),
});